import { BaseMetaColumn } from "./BaseMetaColumn";
import { BaseMetaDatabase } from "./BaseMetaDatabase";

export class BaseMetaTable
{
    database: BaseMetaDatabase | null;
    name: string;
    text: string;
    public columns: { [name: string]: BaseMetaColumn } = {};
    constructor(database: BaseMetaDatabase | null, name: string, text: string)
    {
        this.database = database;
        this.name = name;
        this.text = text;
    }
    forEachColumn<T, MC extends BaseMetaColumn>(handler: (column: MC) => T | null): T | null
    {
        for (const key in this.columns)
        {
            const element = this.columns[key];
            let ans = handler(element as MC);
            if (ans != null)
                return ans;
        }
        return null;
    }
    getColumns<MC extends BaseMetaColumn>(): MC[]
    {
        let ans: MC[] = [];
        this.forEachColumn((column) =>
        {
            ans.push(column as MC);
            return null;
        });
        return ans;
    }
    hasColumn(name: string): boolean
    {
        return this.columns[name] != null;
    }
}